import React, { useState, useEffect } from "react";
import { Container, Card, Button, ListGroup, Row, Col, Alert, Form } from "react-bootstrap";
import { getAlphabetFromIndex,scrollToTop,lmsConfig } from '../../../utils/utils';
import apiClient from "../../../api/apiClient";
import { useLogin } from "../../../context/LoginContext";
import { useLesson } from "../../../context/LessonContext";
import { ASSESSMENTSCORE } from '../../../utils/ApiEndPoint';
const Exercise = ({ lesson }) => {
    const { user } = useLogin();
    const { TrackLessonView, getnextLesson } = useLesson();
    const { title } = lesson?.refDetails;
    const [score, setScore] = useState('');
    const [showResult, setShowResult] = useState(false);
    const [showNext, setShowNext] = useState(false);
    const [error, setError] = useState(null);
    const [questions, setQuestion] = useState([])
    const isDevMode = localStorage.getItem('development') || false;
    const totalQuestionToShow = lmsConfig.totalQuestionToShow ||10;
    useEffect(() => {
        const question = lesson?.refDetails?.questions || [];
        const qLength = question.length;
        const qtoShow = qLength > totalQuestionToShow ? question.slice(0, totalQuestionToShow) : question;
        setError(null);
        setQuestion(qtoShow);
        if (lesson.status === "completed") {
            // if (!showResult) {
                quizReport();
            // }
        } else {
            setScore('');
            setShowResult(false);
        }

    }, [lesson?.status, lesson?.refDetails?.questions?.length]);
    const quizReport = () => {
        apiClient.get(`${ASSESSMENTSCORE}/${user.userId}/${lesson?.refDetails?._id}`)
            .then(response => {
                if(response.status !== 200){
                    setError("Failed to fetch score. Please try again.");
                    return;
                }
                const quizzResultSnapshot = response?.data?.quizzResultSnapshot ? JSON.parse(response?.data?.quizzResultSnapshot) : [];
                const percentage = (response?.data?.score / response?.data?.maxScore) * 100;
                setScore(`${response?.data?.score}/${response?.data?.maxScore}`);
                setShowResult(true);
                setQuestion(quizzResultSnapshot);
                const hasnextLesson = getnextLesson(false);
                if (percentage > 60 && hasnextLesson > -1) {
                    setShowNext(true);
                } else {
                    setShowNext(false);
                }
            })
            .catch(error => {
                console.error("Error fetching score:", error);
                setError("Failed to fetch score. Please try again.");
            });
    };
    const handleOptionClick = (qIdx, optionText, qType) => {
        setQuestion(prev => {
            const newQuestions = prev.map((q, i) => {
                if (i !== qIdx) return q;
                const newOptions = q.options.map(opt => {
                    const isTarget = opt.text === optionText;
                    if (qType === 'MSQ') return { ...opt, selectedAnswer: isTarget ? !opt.selectedAnswer : opt.selectedAnswer };
                    return { ...opt, selectedAnswer: isTarget };
                });
                return { ...q, options: newOptions };
            });
            return newQuestions;
        });
    };

    const validateAllAnswered = () => {
        if (!questions || questions.length === 0) return false;
        return questions.every(q => Array.isArray(q.options) && q.options.some(opt => !!opt.selectedAnswer));
    };
    const handleSubmit = () => {
        if (!validateAllAnswered()) {
            setError("Please answer all questions before submitting.");
            return;
        }
        setError(null);
        let newScore = 0;
        questions.forEach((q, idx) => {
            const correctOptions = q.options.filter(opt => opt.isCorrect).map(opt => opt.text).sort();
            const selectedOptions = q.options.filter(opt => opt.selectedAnswer).map(opt => opt.text).sort();
            if (JSON.stringify(correctOptions) === JSON.stringify(selectedOptions)) {
                newScore += 1;
            }
        });
        const percentage = (newScore / questions.length) * 100;
        setScore(`${newScore}/${questions.length}`);
        setShowResult(true);
        const hasnextLesson = getnextLesson(false);
        if (percentage > 60 && hasnextLesson > -1) {
            setShowNext(true)
        } else {
            setShowNext(false);
        }
        const payload = {
            userId: user.userId,
            quizId: lesson?.refDetails?._id,
            score: newScore,
            maxScore: questions.length,
            quizzResultSnapshot: JSON.stringify(questions)
        };
        TrackLessonView('quiz', "quiz_completed", { score: newScore, maxScore: questions.length });
        apiClient.post(ASSESSMENTSCORE, payload)
            .then(response => {
                console.log("Score submitted successfully:", response.data);
            })
            .catch(error => {
                console.error("Error submitting score:", error);
            })
            .finally(() => {
                scrollToTop('question-list-container');
            });
    };
    const handleReplay = () => {
        const question = lesson?.refDetails?.questions || [];
        const qLength = question.length;
        const qtoShow = qLength > totalQuestionToShow ? question.slice(0, totalQuestionToShow) : question;
        setQuestion(qtoShow)
        setScore('');
        setShowResult(false);
        setError(null);
        scrollToTop('question-list-container');
    };
    return (
        <Container className="my-3">
            <h4 className="mb-3">{title}</h4>
            {showResult && (
                <Alert variant="success"> <h4>Your Score: {score}</h4> </Alert>
            )}
            <Form
                onSubmit={(e) => {
                    e.preventDefault();
                    handleSubmit();
                }}
            >
                {questions.map((q, idx) => {
                    return (<Card className="mb-3 quiz-box" key={q.questionText}>
                        <Card.Body>
                            <Card.Title>
                                <h5>Q{idx + 1}. {q.questionText}</h5>
                            </Card.Title>
                            <ListGroup>
                                {q.options.map((option, index) => {
                                    const optColor= showResult ? (option.isCorrect ? 'green' : (option.selectedAnswer ? 'red' : '#ffffff')) : '#ffffff';
                                    return (<ListGroup.Item key={`${idx}-${index}`} className="p-0 border-0">
                                        <Row className="mb-2">
                                            <Col md={1} xs={3}>
                                                <Form.Check
                                                    type={q.type === 'MSQ' ? 'checkbox' : 'radio'}
                                                    label={<span className="fw-bold">{getAlphabetFromIndex(index)}</span>}
                                                    name={`question-${idx}`}
                                                    checked={!!option?.selectedAnswer}
                                                    onChange={!showResult ? () => handleOptionClick(idx, option.text, q.type) : undefined}
                                                    disabled={showResult}
                                                />
                                            </Col>
                                            <Col md={11} xs={9} style={{border:"solid 2px", borderColor: optColor}}>
                                                {option.text}
                                                {isDevMode && (
                                                    option.isCorrect ? <span className="ms-2 text-success"><i className="fa fa-check" aria-hidden="true"></i></span> : <span className="ms-2 text-danger"><i className="fa fa-times" aria-hidden="true"></i></span>
                                                )}
                                            </Col>
                                        </Row>
                                    </ListGroup.Item>);
                                })}
                            </ListGroup>
                        </Card.Body>
                    </Card>);
                })}
                {error && <Alert variant="danger" className="mt-3">{error}</Alert>}
                {showResult ?
                    <>
                        <Button variant="info" onClick={handleReplay} className="mt-2 me-2" > Replay </Button>
                        {showNext && <Button variant="warning" onClick={getnextLesson} className="mt-2" >  Next </Button>}
                    </>
                    :
                    <Button type="submit" variant="primary" className="mt-3" > Submit </Button>}
            </Form>


        </Container>
    );
};

export default Exercise;